import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled, {css} from 'styled-components';
import {tabletAndUp} from '../../../../constants/customMedia';
import {ImageType} from '../../../../types/Image';
import {Image} from '../../../atoms/Image/Image';
import {Text} from '../../../atoms/Text/Text';

export type MerchantBannerProps = {
  image: ImageType;
  testId?: string;
  className?: string;
};

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export function MerchantBanner({
  className,
  testId,
  image: {description, url},
}: MerchantBannerProps) {
  const {t} = useTranslation();

  return (
    <Container className={className} data-testid={testId || 'merchantBanner'}>
      <StyledText transform="uppercase" color="Grey1" size="px10">
        {t('Sent via')}
      </StyledText>
      <StyledImage
        alt={description}
        src={url}
        ratio="3.5:1"
        importance="low"
        breakpoints={breakpoints}
        widths={widths}
      />
    </Container>
  );
}

const breakpoints = [{columns: 1}];
const widths = [360, 540, 720];

const Container = styled.div``;

const StyledText = styled(Text)`
  display: block;
  margin-bottom: 8px;
  box-sizing: border-box;
`;

const StyledImage = styled(Image)`
  border-radius: 0px;
  margin: 0 -20px;
  width: calc(100% + 40px);
  ${tabletAndUp(
    css`
      margin: 0;
    `,
  )}
`;
